import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box, Text } from '@hivewatch/dark'

import { getRoleDisplayName } from '@/features/managed-accounts'
import { NotificationSubtitle } from '@/features/notification'
import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationsTabTokens } from '../../styles/tokens'

export const ClearNotification = ({
  notification,
  onClick,
}: {
  notification: Notification
  onClick: () => void
}) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const tokens = getNotificationsTabTokens(colorScheme)
  const senderDisplayName = `${getRoleDisplayName(
    notification?.incidentActionUserRole
  )} ${notification?.incidentActionUserName}`
  return (
    <Box color={tokens.textPrimary} cursor='pointer' flex={1} onClick={onClick}>
      <Text
        data-testid='ClearNotification:header'
        lineClamp={2}
        mb={1.5}
        textStyle='label'
      >
        {senderDisplayName} {t('common:notification_cleared')}{' '}
        <Box as='span' color={tokens.incidentLink} textStyle='label'>
          {notification.incidentDisplayId} {notification.incidentName}
        </Box>
      </Text>
      <NotificationSubtitle
        facilityShortName={notification?.facilityShortName}
        fontSize='11px'
        sourceName={notification?.incidentSourceName}
        timestamp={notification?.notificationTimestamp}
      />
    </Box>
  )
}
